export default __webpack_public_path__ + "static/media/asepsis-logo.be69fee9.svg";